import { render } from "./PetVetPromo.vue?vue&type=template&id=b5f01bfc&scoped=true"
import script from "./PetVetPromo.vue?vue&type=script&lang=js"
export * from "./PetVetPromo.vue?vue&type=script&lang=js"

import "./PetVetPromo.vue?vue&type=style&index=0&id=b5f01bfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5f01bfc"]])

export default __exports__